module.exports = __webpack_public_path__ + "static/media/setinha_branca.f2015649.svg";